import React from 'react';
import Cart from '../../../features/store/cart/Cart';

function CartView() {
  return (
    <Cart />
  );
}

export default CartView;